import React from "react";
function StateLabel(props) {
  const stateBgMap = {
    created: "bg-light-primary",
    enabled: "bg-light-success",
    disabled: "bg-light",
    deleted: "bg-light-danger",
  };

  return (
    <>
      {props.stateLabel && (
        <span
          className={`label text-nowrap label-inline ${props.className} ${
            stateBgMap[props.stateCode]
          }`}
        >
          {props.stateLabel}
        </span>
      )}
    </>
  );
}

export default StateLabel;
